import React from "react";
import { Link } from "react-router-dom";
import { Zap, Mail } from "./Icons";

const footerLinks = {
  product: [
    { label: "Features", href: "/#features" },
    { label: "Pricing", href: "/pricing" },
    { label: "Use Cases", href: "/#use-cases" },
    { label: "Feedback", href: "https://tally.so/r/xXaX7r" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
  ],
};

export const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 dark:bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-indigo-600 rounded-lg p-1.5">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <span className="font-bold text-xl text-white tracking-tight">
                taskplan
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Progressive automation for modern teams. Turn manual runbooks into
              reliable, automated workflows.
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="mailto:support@taskplan.run"
                className="text-slate-400 hover:text-white text-sm transition-colors flex items-center gap-2"
              >
                <Mail size={16} />
                Email us at support@taskplan.run
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Product
            </h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Taskplan. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            Made with ♥ for operations teams everywhere
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
